import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { format } from "date-fns";

import { useCheckinModal } from "./use-checkin-modal";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";
import { getEmployeeCheckinsQueryOptions } from "@/config/queries/query-options";
import { useMemo } from "react";
import { DataTable } from "./checkin-table/data-table";
import { columns } from "./checkin-table/columns";

export const CheckinModal = () => {
  const key = Cookies.get("key") as string;
  const { open, onOpenChange, checkinId } = useCheckinModal();

  const { data, isPending } = useQuery(
    getEmployeeCheckinsQueryOptions(key, checkinId)
  );

  const checkinsData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.checkins === undefined) {
      return [];
    }

    const result = data?.checkins?.map((checkin) => {
      return {
        id: checkin?._id,
        mode: checkin?.mode === "IN" ? "Check in" : "Check out",
        time: format(new Date(checkin?.createdAt as Date), "PPpp"),
        createdAtIST: checkin?.createdAtIST,
        workDoneToday: checkin?.workDoneToday,
        attachments: checkin?.attachments,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAtIST).getTime() -
        new Date(a?.createdAtIST).getTime()
    );
  }, [isPending, data]);

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-5xl">
          <DialogHeader>
            <DialogTitle>Employee Checkins</DialogTitle>
          </DialogHeader>

          <div className="mt-5">
            <DataTable data={checkinsData} columns={columns} />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
